import tenants from 'Constants/tenants'
import {
  FC,
  ReactElement,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import styled from 'styled-components'
import { TenantKey } from 'Types/MicroFrontendProps'
import colorVariables from '../Globals/colors.module.css'

interface DevToolProps {
  setTenant: (newVal: TenantKey) => void
  setIsDarkmode: (newVal: SetStateAction<boolean>) => void
  isDarkmode: boolean
  currentTenantKey: TenantKey
  children?: ReactElement
}
const DevTools: FC<DevToolProps> = ({
  setTenant,
  setIsDarkmode,
  isDarkmode,
  currentTenantKey,
  children,
}): ReactElement => {
  const [showDevTools, setShowDevTools] = useState(false)
  const globalClasses = [
    colorVariables.globalColors,
    isDarkmode ? colorVariables.globalColorsDark : '',
  ]
  function darkmodeClicked() {
    const newVal = !isDarkmode
    setIsDarkmode(newVal)
    localStorage.setItem('isDarkmode', JSON.stringify(newVal))
  }
  function tenantClicked(tenantKey: TenantKey) {
    setTenant(tenantKey)
    localStorage.setItem('tenantKey', JSON.stringify(tenantKey))
  }
  useEffect(() => {
    if (localStorage.getItem('isDarkmode')) {
      setIsDarkmode(JSON.parse(localStorage.getItem('isDarkmode') as string))
    }
    if (localStorage.getItem('tenantKey')) {
      setTenant(JSON.parse(localStorage.getItem('tenantKey') as string))
    }
  }, [])
  return (
    <Background className={globalClasses.join(' ')}>
      <div id='dev-tools-container'>
        <Title
          isOpen={showDevTools}
          id='dev-tools-title'
          onClick={() => setShowDevTools(!showDevTools)}
        >
          <span className='icon'>
            <svg
              width='12px'
              height='12px'
              viewBox='0 0 12 12'
              xmlns='http://www.w3.org/2000/svg'
            >
              <polyline
                fill='none'
                strokeWidth='1.5'
                points='2 4 6.2560339 8.2560339 10.5120678 4'
              ></polyline>
            </svg>
          </span>
          Toggle Devtools
        </Title>
        <ToolsContainer isOpen={showDevTools}>
          {showDevTools && (
            <div>
              <div className='tool'>
                <span>Darkmode:</span>
                <input
                  type='button'
                  value={isDarkmode ? 'off' : 'on'}
                  onClick={() => darkmodeClicked()}
                />
              </div>
              <div className='tool'>
                <span>Tenant:</span>
                <select
                  value={currentTenantKey}
                  onChange={(event) =>
                    tenantClicked(event.target.value as TenantKey)
                  }
                >
                  {tenants.map((tenant) => (
                    <option key={tenant.key} value={tenant.key}>
                      {tenant.name}
                    </option>
                  ))}
                </select>
              </div>
              {process.env.REACT_APP_DEPLOY_PATH && (
                <a
                  onClick={(e) => {
                    e.preventDefault()
                    navigator.clipboard.writeText(
                      process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
                    )
                  }}
                  href={
                    process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
                  }
                >
                  Copy path to JS 🔗
                </a>
              )}
            </div>
          )}
        </ToolsContainer>
      </div>
      {children && children}
    </Background>
  )
}
// ⚠️ static CSS is under public/index.html
const Title = styled.b<{ isOpen: boolean }>`
  display: inline-flex;
  color: var(--text-color);
  user-select: none;

  .icon {
    padding-top: 2px;
    transform: rotate3d(0, 0, 1, ${(props) => (props.isOpen ? '180deg' : '0')});
    transition: transform 0.3s ease;
    svg {
      display: block;
      stroke: currentColor;
    }
  }
`
const ToolsContainer = styled.div<{ isOpen: boolean }>`
  max-height: ${(props) => (props.isOpen ? '400px' : '0px')};
  max-width: ${(props) => (props.isOpen ? '400px' : '0px')};
  transition: all 0.3s ease;
  color: var(--text-color);
`
const Background = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: var(--site-background);
`
export default DevTools
